import React from 'react';
import {
  Grid,
  Paper,
  Box,
  Typography,
  CircularProgress,
  Skeleton,
} from '@mui/material';
import InboxIcon from '@mui/icons-material/Inbox';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import SpeedIcon from '@mui/icons-material/Speed';
import TimerOffIcon from '@mui/icons-material/TimerOff';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

const cardStyles = (bg) => ({
  p: 2,
  display: 'flex',
  gap: 2,
  alignItems: 'center',
  borderRadius: 2,
  minHeight: 100,
  boxShadow: '0 6px 18px rgba(15,23,42,0.06)',
  background: bg || '#fff',
  cursor: bg ? 'pointer' : 'default',
});

export default function AgentKPICards({ data, cards: customCards, loading, onCardClick }) {
  const values = data || {};
  const defaultCards = [
    {
      id: 'available',
      title: 'Available Orders',
      icon: <InboxIcon color="primary" sx={{ fontSize: 36 }} />,
      value: values.available ?? 0,
    },
    {
      id: 'assigned',
      title: 'Assigned Orders',
      icon: <AssignmentTurnedInIcon sx={{ color: '#6a4bd8', fontSize: 36 }} />,
      value: values.assigned ?? 0,
    },
    {
      id: 'completed',
      title: 'Completed Orders',
      icon: <CheckCircleIcon color="success" sx={{ fontSize: 36 }} />,
      value: values.completed ?? 0,
    },
    {
      id: 'todayCommission',
      title: "Today's Commission",
      icon: <MonetizationOnIcon color="success" sx={{ fontSize: 36 }} />,
      value: values.todayCommission ?? '₹0',
    },
    {
      id: 'acceptance',
      title: 'Acceptance Rate',
      icon: <SpeedIcon color="info" sx={{ fontSize: 36 }} />,
      value: values.acceptance ?? 0,
      progress: true,
    },
    {
      id: 'lost',
      title: 'Orders Lost',
      icon: <TimerOffIcon color="error" sx={{ fontSize: 36 }} />,
      value: values.lost ?? 0,
    },
    {
      id: 'winrate',
      title: 'Win Rate',
      icon: <EmojiEventsIcon sx={{ color: '#d4af37', fontSize: 36 }} />,
      value: values.winrate ?? 0,
      progress: true,
    },
  ];

  const cards = customCards || defaultCards;

  return (
    <Grid container spacing={2}>
      {cards.map((c) => (
        <Grid item xs={12} sm={6} md={3} key={c.id}>
          <Paper
            onClick={() => onCardClick?.(c.id)}
            sx={cardStyles(onCardClick ? '#fff' : undefined)}
            elevation={1}
            role={onCardClick ? 'button' : undefined}
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>{c.icon}</Box>

            <Box sx={{ flex: 1 }}>
              <Typography variant="subtitle2" color="text.secondary">
                {c.title}
              </Typography>

              {loading ? (
                <Skeleton width={120} height={34} />
              ) : c.progress ? (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Typography variant="h6" fontWeight={700}>
                    {typeof c.value === 'number' ? `${c.value}%` : c.value}
                  </Typography>
                  <CircularProgress
                    variant="determinate"
                    value={Number(c.value)}
                    size={48}
                    thickness={5}
                  />
                </Box>
              ) : (
                <Typography variant="h6" fontWeight={700}>
                  {c.value}
                </Typography>
              )}
            </Box>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
}
